<div
  class="card m-auto"
  style="
    font-family: Avenir, Avenir Next, Segoe UI, Helvetica, Arial, sans-serif;
  "
>
  <div class="card-header card-chart card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11 align-self-center">
        <h2 class="card-title text-center">
          {{ titleModal }}
        </h2>
      </div>
      <div class="col-sm-12 col-md-1">
        <button mat-icon-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body" id="card-content-oportunidad">
    <div class="container-fluid">
      <form [formGroup]="formStageEmployee">
        <div class="row">
          <div class="col-md-5">
            <!-- Tipo de oportunidad -->
            <mat-form-field>
              <mat-label>Tipo de oportunidad</mat-label>
              <mat-select
                placeholder="Selecciona el tipo de oportunidad"
                formControlName="tipoOportunidadCtrl"
                (selectionChange)="seleccionaTipoOp()"
                required
              >
                <mat-option
                  *ngFor="let tipo of tiposOportunidad"
                  [value]="tipo"
                >
                  {{ tipo.nombre_tipo }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Nombre corto cliente -->
            <div class="row" *ngIf="clientefl != null">
              <div class="col-md 12 mb-2">
                NOMBRE CORTO DEL CLIENTE:<span class="fw-bold">
                  {{ proyecto.nombre_corto }}</span
                >
              </div>
            </div>

            <!-- Cliente -->
            <div class="row">
              <div class="col-md-9 col-sm-10">
                <mat-form-field appearance="outline">
                  <mat-label>Selecciona un cliente</mat-label>
                  <mat-select
                    formControlName="customerCtrl"
                    required
                    (selectionChange)="seleccionCliente($event)"
                  >
                    <ngx-mat-select-search
                      [formControl]="formCliente"
                      [placeholderLabel]="'Buscar Cliente'"
                      [noEntriesFoundLabel]="'No existe cliente'"
                    >
                    </ngx-mat-select-search>
                    <mat-option
                      *ngFor="let cliente of clientes"
                      [value]="cliente.id"
                    >
                      {{ cliente.razonsocial }}
                    </mat-option>
                  </mat-select>
                  <button mat-button matSuffix (click)="clearNombreCli()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div class="col-md-3 col-sm-2">
                <mat-icon
                  style="cursor: pointer"
                  matTooltip="Agregar cliente"
                  (click)="agregarCliente()"
                  (keydown.enter)="agregarCliente()"
                  [matTooltipPosition]="'above'"
                  >mode_edit</mat-icon
                >
              </div>
            </div>

            <!-- Producto -->
            <div class="row">
              <div
                class="col-md-9 col-sm-10"
                *ngIf="clientefl != null || !idGeneradoExito"
              >
                <div *ngIf="!esNuevoProducto && listProducto.length > 0">
                  <mat-form-field appearance="outline" *ngIf="!idGeneradoExito">
                    <mat-select
                      placeholder="Selecciona un producto"
                      (selectionChange)="seleccionarProducto($event)"
                      formControlName="productoCtrl"
                    >
                      <mat-option
                        *ngFor="let prod of listProducto"
                        [value]="prod.id_producto"
                      >
                        {{ prod.producto }}
                      </mat-option>
                    </mat-select>
                    <mat-label>Selecciona un producto</mat-label>
                  </mat-form-field>
                </div>

                <!-- Nuevo producto -->
                <mat-form-field *ngIf="esNuevoProducto">
                  <div style="display: flex; align-items: center">
                    <input
                      aria-label="Nombre del producto:"
                      matInput
                      placeholder="Nombre del producto:"
                      formControlName="nombreProducto"
                      maxlength="45"
                      required
                    />
                    <button
                      mat-icon-button
                      color="primary"
                      *ngIf="
                        formStageEmployee.get('nombreProducto').value != ''
                      "
                      (click)="guardaProducto()"
                    >
                      <mat-icon>add_circle</mat-icon>
                    </button>
                  </div>
                </mat-form-field>
              </div>

              <div
                class="col-md-3 col-sm-2 text-center"
                *ngIf="!idGeneradoExito && idClienteRelacionado != null"
              >
                <span class="h6">Nuevo producto</span>
                <p>
                  <mat-checkbox
                    class="text-center"
                    [checked]="esNuevoProducto === true"
                    matTooltip="Agregar nuevo producto"
                    (change)="nuevoProducto($event)"
                  >
                  </mat-checkbox>
                </p>
              </div>
            </div>

            <!-- Servicio -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" *ngIf="!idGeneradoExito">
                  <mat-select
                    placeholder="Selecciona un servicio"
                    (selectionChange)="seleccionarServicio($event)"
                    formControlName="servicioCtrl"
                  >
                    <mat-option
                      *ngFor="let servicio of listServicios"
                      [value]="servicio.id"
                    >
                      {{ servicio.descripcion }}
                    </mat-option>
                  </mat-select>
                  <mat-label>Selecciona un servicio</mat-label>
                </mat-form-field>
                <div class="" *ngIf="idGeneradoExito">
                  ID PROYECTO:
                  <span class="fw-bold">{{ idGenerado.idProyecto }}</span>
                </div>
              </div>
            </div>

            <!-- Grupo -->
            <div class="row">
              <div class="col-md-9 col-sm-10" *ngIf="mostrarGrupos">
                <mat-form-field appearance="outline">
                  <mat-label>Selecciona un grupo</mat-label>
                  <mat-select formControlName="groupCtrl" required>
                    <ngx-mat-select-search
                      [formControl]="formGrupo"
                      [placeholderLabel]="'Buscar grupo'"
                      [noEntriesFoundLabel]="'No existe el grupo'"
                    >
                    </ngx-mat-select-search>
                    <mat-option
                      *ngFor="let grupo of listaGruposXTipo"
                      [value]="grupo.name"
                    >
                      {{ grupo.name }}
                    </mat-option>
                  </mat-select>
                  <button mat-button matSuffix (click)="clearNombreGrup()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div
                class="col-md-3 col-sm-2"
                style="margin-top: 10px"
                *ngIf="mostrarGrupos"
              >
                <mat-icon
                  style="cursor: pointer"
                  matTooltip="Agregar grupo"
                  (click)="agregarGrupo()"
                  (keydown.enter)="agregarGrupo()"
                  [matTooltipPosition]="'above'"
                  >mode_edit</mat-icon
                >
              </div>
            </div>

            <!-- Estimación requerida -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <mat-label>Estimación requerida</mat-label>
                  <input
                    aria-label="Estimación requerida"
                    matInput
                    [matDatepicker]="picker"
                    formControlName="dateEstimateProjectCtrl"
                    [min]="minDate"
                    [max]="maxDate"
                    readonly
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <!-- Descripción breve -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <mat-label>Descripción breve del proyecto</mat-label>
                  <textarea
                    aria-label="Descripción breve del proyecto"
                    maxlength="500"
                    matInput
                    formControlName="descriptionProjectCtrl"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Col derecha -->
          <div class="col-md-7">
            <!-- Nombre proyecto -->
            <mat-form-field>
              <mat-label>Nombre de proyecto</mat-label>
              <input
                aria-label="Nombre de proyecto"
                cdkFocusInitial
                matInput
                required
                formControlName="nameProjectCtrl"
                maxlength="150"
              />
            </mat-form-field>

            <!-- Comentarios -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <mat-label>Comentarios</mat-label>
                  <textarea
                    aria-label="Comentarios"
                    maxlength="500"
                    matInput
                    formControlName="commentProjectCtrl"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>

            <!-- Archivos -->
            <div class="row">
              <div class="card" style="min-height: auto">
                <div
                  class="card-header card-header-tabs card-header-warning pt-1 pb-1"
                >
                  <div class="nav-tabs-navigation">
                    <div class="nav-tabs-wrapper">
                      <span class="nav-tabs-title"
                        >Cargar requerimiento, solicitud, correos, etc:
                      </span>
                      <ul class="nav nav-tabs" data-tabs="tabs">
                        <li class="nav-item" style="cursor: pointer">
                          <button
                            class="btn-file nav-link"
                            [disabled]="btnAgrega"
                            style="cursor: pointer"
                            matTooltip="Cargar archivo"
                          >
                            <a style="cursor: pointer">
                              <i class="material-icons">upload_file</i> Agregar
                            </a>
                            <input
                              aria-label="Agregar"
                              type="file"
                              id="nameFile"
                              accept=".eml, .msg, image/*, application/*,file_extension|audio/*|video/mp4,video/*|image/*|media_type"
                              mozdirectory
                              directory
                              multiple
                              (change)="subirEv()"
                            />
                          </button>
                          <div class="ripple-container"></div>
                        </li>
                        <li
                          class="nav-item"
                          style="cursor: pointer"
                          [hidden]="btnElimina"
                        >
                          <button
                            class="nav-link"
                            (click)="elimina()"
                            matTooltip="Remover archivo"
                          >
                            <a>
                              <i class="material-icons">delete_forever</i>
                              Remover</a
                            >
                          </button>
                          <div class="ripple-container"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <mat-selection-list
                    style="max-height: 230px; overflow: auto"
                    [(ngModel)]="selectedOptions"
                    (ngModelChange)="onNgModelChange($event)"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <mat-list-option
                      *ngFor="
                        let item of evidencia || data.archivos;
                        index as i
                      "
                      [value]="item"
                      class="text-muted"
                    >
                      <p class="text-muted">{{ item.name }}</p>
                    </mat-list-option>
                  </mat-selection-list>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div class="row">
          <div mat-dialog-actions class="justify-content-end">
            <button
              [hidden]="modeEditable"
              mat-raised-button
              class="btn btn-link btn-pinterest"
              (click)="clear()"
            >
              <i class="fa fa fa-trash-o"></i> Limpiar
            </button>
            <button
              mat-button
              (click)="save()"
              class="btn btn-success"
              [disabled]="!formStageEmployee.valid"
            >
              Guardar <i class="material-icons"> save </i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
